export default {
  lections: null,
  lection: null,
  courses: null
};
